// extracted by mini-css-extract-plugin
module.exports = {"container":"_13914","innerContainer":"_1sYGb","title":"tIIKl","body":"P0VzJ","button":"_2dt5G","isMuted":"_2-TNl"};